import {html} from "lit";
import {customElement} from "lit/decorators/custom-element.js";
import {property} from "lit/decorators/property.js";
import {ifDefined} from "lit/directives/if-defined.js";
import {createRef, Ref, ref} from "lit/directives/ref.js";
import {when} from "lit/directives/when.js";
import {DateTime} from "luxon";
import {UuidHelper} from "../../../helpers/uuid.helper";
import {AbstractInputComponent} from "../abstract-input.component";

@customElement(`ha-input-date`)
export class HaInputDateComponent extends AbstractInputComponent {

    @property({type: Object})
    public max: DateTime | null = null;

    @property({type: Object})
    public min: DateTime | null = null;

    @property({type: Object})
    public value: DateTime | null = DateTime.utc().startOf(`day`);

    private _id: string = UuidHelper.generateV7();

    private _inputRef: Ref<HTMLInputElement> = createRef<HTMLInputElement>();

    protected render(): unknown {
        return html`
            ${when(this.label, () => html`
                    <label for=${this._id}>${this.label}</label>
            `)}
            <div class="wrapper">                
                <input ${ref(this._inputRef)}
                       id=${this._id}
                       type="date"
                       .value=${this.value ? this.value.toLocal().toISODate() : ``}
                       @input=${this._onInputDate}
                       ?disabled=${this.readonly}
                       min=${ifDefined(this.min?.toLocal().toISODate())}
                       max=${ifDefined(this.max?.toLocal().toISODate())}
                >
            </div>    
            ${this._renderHelperText()}
            ${this._renderErrors()}
        `;
    }

    private _onInputDate(evt: Event): void {
        const valueString = (evt.target as HTMLInputElement).value ?? ``;
        const oldValue = this.value;
        const newValue = (valueString.length > 0)
            ? DateTime.fromISO(valueString, {zone: `utc`}).startOf(`day`)
            : null

        if (newValue?.valueOf() === oldValue?.valueOf()) {
            return;
        }

        if (newValue instanceof DateTime && oldValue instanceof DateTime && newValue.equals(oldValue)) {
            return;
        }

        this.value = newValue;

        this.dispatchEvent(
            new CustomEvent<{ value: DateTime | null }>(`value-changed`, {detail: {value: newValue}})
        )
    }
}

declare global {
    interface HTMLElementTagNameMap {
        'ha-input-date': HaInputDateComponent;
    }
}